"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomeFixedAddonWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var services_1 = require("@falcon/services");
var modals = require("./tierTable/TierTableInfoModalRenderers");
var InfoModal_1 = require("../../../components/modals/InfoModal");
var SuggestionModal_1 = require("../../../components/modals/SuggestionModal");
var journey_model_1 = require("@athena-portal/journey-model");
var journey_services_1 = require("@athena-portal/journey-services");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualHomeFixedAddonWidget = exports.AnnualHomeFixedAddonWidget = /** @class */ (function (_super) {
    __extends(AnnualHomeFixedAddonWidget, _super);
    function AnnualHomeFixedAddonWidget(props) {
        var _this = this;
        var _a, _b, _c, _d;
        _this = _super.call(this, props) || this;
        // @ts-ignore
        _this.handleOnChangeEvent = function (addonName) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var selected = false;
            if (addonName === services_1.BUILDING_ACCIDENTAL_DAMAGE) {
                selected = ((_a = _this.props.interaction.annualHomeFixedAddons) === null || _a === void 0 ? void 0 : _a.buildingAccidentalDamage) ? (_b = _this.props.interaction.annualHomeFixedAddons) === null || _b === void 0 ? void 0 : _b.buildingAccidentalDamage : false;
                journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.buildingAccidentalDamage", _this.props.interaction, !selected);
                journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.buildingAccidentalDamage", _this.props.interaction, !selected);
                if (!_this.state.buildingsAccidentalDamageWasAddedOnce) {
                    _this.setState({ buildingsAccidentalDamageWasAddedOnce: true });
                    _this.toggleSuggestionModal();
                }
            }
            else if (addonName === services_1.CONTENTS_ACCIDENTAL_DAMAGE) {
                selected = ((_c = _this.props.interaction.annualHomeFixedAddons) === null || _c === void 0 ? void 0 : _c.contentsAccidentalDamage) ? (_d = _this.props.interaction.annualHomeFixedAddons) === null || _d === void 0 ? void 0 : _d.contentsAccidentalDamage : false;
                journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.contentsAccidentalDamage", _this.props.interaction, !selected);
                journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.contentsAccidentalDamage", _this.props.interaction, !selected);
                if (!_this.state.contentsAccidentalDamageWasAddedOnce) {
                    _this.setState({ contentsAccidentalDamageWasAddedOnce: true });
                    _this.toggleSuggestionModal();
                }
            }
            else if (addonName === services_1.HOME_LEGAL_EXPENSES) {
                selected = ((_e = _this.props.interaction.annualHomeFixedAddons) === null || _e === void 0 ? void 0 : _e.homeLegalExpenses) ? (_f = _this.props.interaction.annualHomeFixedAddons) === null || _f === void 0 ? void 0 : _f.homeLegalExpenses : false;
                journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.homeLegalExpenses", _this.props.interaction, !selected);
                journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.homeLegalExpenses", _this.props.interaction, !selected);
                if (!_this.state.homeLegalExpensesWasAddedOnce) {
                    _this.setState({ homeLegalExpensesWasAddedOnce: true });
                    _this.toggleSuggestionModal();
                }
            }
            else if (addonName === services_1.HOME_EMERGENCY) {
                selected = ((_g = _this.props.interaction.annualHomeFixedAddons) === null || _g === void 0 ? void 0 : _g.homeEmergency) ? (_h = _this.props.interaction.annualHomeFixedAddons) === null || _h === void 0 ? void 0 : _h.homeEmergency : false;
                journey_services_1.ObjectManipulator.setField("annualHomeFixedAddons.homeEmergency", _this.props.interaction, !selected);
                journey_services_1.ObjectManipulator.setField("uistate.annualHomeAddonsState.homeEmergency", _this.props.interaction, !selected);
                if (!_this.state.homeEmergencyWasAddedOnce) {
                    _this.setState({ homeEmergencyWasAddedOnce: true });
                    _this.toggleSuggestionModal();
                }
            }
            _this.executeEvent("change");
        };
        _this.state = {
            isSuggestionModalOpen: false,
            buildingsAccidentalDamageWasAddedOnce: !!((_a = _this.props.interaction.annualHomeFixedAddons) === null || _a === void 0 ? void 0 : _a.buildingAccidentalDamage),
            contentsAccidentalDamageWasAddedOnce: !!((_b = _this.props.interaction.annualHomeFixedAddons) === null || _b === void 0 ? void 0 : _b.contentsAccidentalDamage),
            homeLegalExpensesWasAddedOnce: !!((_c = _this.props.interaction.annualHomeFixedAddons) === null || _c === void 0 ? void 0 : _c.homeLegalExpenses),
            homeEmergencyWasAddedOnce: !!((_d = _this.props.interaction.annualHomeFixedAddons) === null || _d === void 0 ? void 0 : _d.homeEmergency)
        };
        _this.toggleSuggestionModal = _this.toggleSuggestionModal.bind(_this);
        return _this;
    }
    AnnualHomeFixedAddonWidget.prototype.render = function () {
        var _a, _b, _c, _d;
        var isMonthly = this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_MONTHLY;
        var showTierWarning = this.getSetting("showTierWarning", true);
        var buildingAccidentalDamage = {
            name: services_1.BUILDING_ACCIDENTAL_DAMAGE,
            wording: "Buildings Accidental Damage",
            image: "buildings-accidental-damage.png",
            modalHeader: "Buildings Accidental Damage",
            showAmount: false
        };
        var contentsAccidentalDamage = {
            name: services_1.CONTENTS_ACCIDENTAL_DAMAGE,
            wording: "Contents Accidental Damage",
            image: "contents-accidental-damage.png",
            modalHeader: "Contents Accidental Damage",
            showAmount: false
        };
        var homeLegalExpenses = {
            name: services_1.HOME_LEGAL_EXPENSES,
            wording: "Home Legal Expenses",
            image: "homeLegal-expenses.png",
            amount: isMonthly ? (_a = this.props.interaction.annualHomeFixedAddons) === null || _a === void 0 ? void 0 : _a.monthlyLegalExpensesPremium : (_b = this.props.interaction.annualHomeFixedAddons) === null || _b === void 0 ? void 0 : _b.annualLegalExpensesPremium,
            modalHeader: "Home Legal Expenses",
            showAmount: true
        };
        var homeEmergency = {
            name: services_1.HOME_EMERGENCY,
            wording: "Home Emergency",
            image: "home-emergency.png",
            amount: isMonthly ? (_c = this.props.interaction.annualHomeFixedAddons) === null || _c === void 0 ? void 0 : _c.monthlyHomeEmergencyPremium : (_d = this.props.interaction.annualHomeFixedAddons) === null || _d === void 0 ? void 0 : _d.annualHomeEmergencyPremium,
            modalHeader: "Home Emergency",
            showAmount: true
        };
        var isPremier = this.props.interaction.coverTier === services_1.GOLD_TIER;
        return (React.createElement(React.Fragment, null,
            this.renderAddon(buildingAccidentalDamage),
            this.renderAddon(contentsAccidentalDamage),
            this.renderAddon(homeLegalExpenses),
            this.renderAddon(homeEmergency),
            showTierWarning && this.props.interaction.process === services_1.INTERACTION_PROCESS_NB && !isPremier && this.state.isSuggestionModalOpen && this.renderSuggestionModal()));
    };
    AnnualHomeFixedAddonWidget.prototype.renderAddon = function (addon) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        // @ts-ignore
        var isMonthly = this.props.interaction.factors.premiumType === services_1.PREMIUM_TYPE_MONTHLY;
        var isPremier = this.props.interaction.coverTier === services_1.GOLD_TIER;
        var selected = false;
        var isAllianz = services_1.resourcesHelper.THEME === "Allianz";
        if (addon.name === services_1.BUILDING_ACCIDENTAL_DAMAGE) {
            selected = ((_a = this.props.interaction.annualHomeFixedAddons) === null || _a === void 0 ? void 0 : _a.buildingAccidentalDamage) ? (_b = this.props.interaction.annualHomeFixedAddons) === null || _b === void 0 ? void 0 : _b.buildingAccidentalDamage : false;
        }
        else if (addon.name === services_1.CONTENTS_ACCIDENTAL_DAMAGE) {
            selected = ((_c = this.props.interaction.annualHomeFixedAddons) === null || _c === void 0 ? void 0 : _c.contentsAccidentalDamage) ? (_d = this.props.interaction.annualHomeFixedAddons) === null || _d === void 0 ? void 0 : _d.contentsAccidentalDamage : false;
        }
        else if (addon.name === services_1.HOME_LEGAL_EXPENSES) {
            selected = ((_e = this.props.interaction.annualHomeFixedAddons) === null || _e === void 0 ? void 0 : _e.homeLegalExpenses) ? (_f = this.props.interaction.annualHomeFixedAddons) === null || _f === void 0 ? void 0 : _f.homeLegalExpenses : false;
        }
        else if (addon.name === services_1.HOME_EMERGENCY) {
            selected = ((_g = this.props.interaction.annualHomeFixedAddons) === null || _g === void 0 ? void 0 : _g.homeEmergency) ? (_h = this.props.interaction.annualHomeFixedAddons) === null || _h === void 0 ? void 0 : _h.homeEmergency : false;
        }
        if (isPremier) {
            return (React.createElement("div", { className: "fixed-addon-background-selected quote row mt-2 pb-0" },
                React.createElement("div", { className: "col p-0 d-flex align-items-start fixed-addon-item" },
                    React.createElement("img", { className: "fixed-addon-icon float-start", src: "/".concat(services_1.resourcesHelper.THEME, "/img/fixed-addon-selected-tick.png"), alt: "addon selected icon" }),
                    React.createElement("div", { className: "w-100" },
                        React.createElement("div", { className: "heading-info" },
                            React.createElement("p", { className: "font-weight-bold mb-0 heading" }, addon.wording),
                            isAllianz && React.createElement("div", { className: "fixed-addon-info" }, this.renderModal(addon))),
                        React.createElement("p", { className: "mt-0 mb-0" }, "Included as standard"))),
                !isAllianz && React.createElement("div", { className: "fixed-addon-info" }, this.renderModal(addon))));
        }
        else {
            return (React.createElement("div", { className: "".concat(selected ? "fixed-addon-background-selected quote row mt-2 pb-0" : "fixed-addon-background quote row mt-2 pb-0") },
                React.createElement("div", { className: "col p-0 d-flex align-items-start fixed-addon-item" },
                    !selected &&
                        React.createElement("img", { className: "fixed-addon-icon flex-start", src: "/".concat(services_1.resourcesHelper.THEME, "/img/").concat(addon.image), alt: "addon icon" }),
                    selected &&
                        React.createElement("img", { className: "fixed-addon-icon flex-start", src: "/".concat(services_1.resourcesHelper.THEME, "/img/fixed-addon-selected-tick.png"), alt: "addon selected icon" }),
                    React.createElement("div", { className: "w-100" },
                        React.createElement("div", { className: "heading-info" },
                            React.createElement("p", { className: "font-weight-bold mb-0 heading" }, addon.wording),
                            isAllianz && React.createElement("div", { className: "fixed-addon-info" }, this.renderModal(addon))),
                        this.renderAmountWordingFragment(selected, isMonthly, addon),
                        React.createElement("p", { className: "mt-0 mb-0 font-weight-bold margin-top-32" },
                            React.createElement("span", { className: "clickable-area", onClick: function () { return _this.handleOnChangeEvent(addon.name); } }, selected ? "-\u00A0" : "+\u00A0"),
                            React.createElement("span", { className: "blue-link-underline clickable-area", onClick: function () { return _this.handleOnChangeEvent(addon.name); } }, selected ? "Remove" : "Add")))),
                !isAllianz && React.createElement("div", { className: "fixed-addon-info" }, this.renderModal(addon))));
        }
    };
    AnnualHomeFixedAddonWidget.prototype.renderAmountWordingFragment = function (selected, isMonthly, addon) {
        if (addon.showAmount) {
            return (React.createElement("p", { className: "mt-0 mb-0" },
                selected && "Added for ",
                React.createElement("span", { className: "font-weight-bold" }, (0, commonFunctions_1.getAmountWithDecimalDigits)(addon.amount)),
                isMonthly ? " / month" : " / year"));
        }
        else if (selected) {
            return (React.createElement("p", { className: "mt-0 mb-0" }, "Added"));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualHomeFixedAddonWidget.prototype.renderModal = function (addon) {
        return React.createElement(InfoModal_1.InfoModal, { className: "fixed-addon-info-icon mt-3 white-bg", title: addon.modalHeader }, this.renderModalBody(addon.name));
    };
    AnnualHomeFixedAddonWidget.prototype.renderModalBody = function (addonName) {
        if (addonName === services_1.BUILDING_ACCIDENTAL_DAMAGE) {
            return modals.renderBuildingsAccidentalDamageModal();
        }
        else if (addonName === services_1.CONTENTS_ACCIDENTAL_DAMAGE) {
            return modals.renderContentsAccidentalDamageModal();
        }
        else if (addonName === services_1.HOME_LEGAL_EXPENSES) {
            return modals.renderLegalExpensesModal();
        }
        else if (addonName === services_1.HOME_EMERGENCY) {
            return modals.renderHomeEmergencyModal();
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    AnnualHomeFixedAddonWidget.prototype.renderSuggestionModal = function () {
        var modalTitle = "Because of the changes you've made...";
        return (React.createElement(SuggestionModal_1.SuggestionModal, { title: modalTitle, isSuggestionModalOpen: this.state.isSuggestionModalOpen, toggleSuggestionModal: this.toggleSuggestionModal }, modals.renderFlowPremierSuggestionModal()));
    };
    AnnualHomeFixedAddonWidget.prototype.toggleSuggestionModal = function () {
        this.setState(function (state) { return ({
            isSuggestionModalOpen: !state.isSuggestionModalOpen
        }); });
    };
    AnnualHomeFixedAddonWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "showTierWarning", type: journey_model_1.TypeDescriptions.Boolean }
        ]),
        __metadata("design:paramtypes", [Object])
    ], AnnualHomeFixedAddonWidget);
    return AnnualHomeFixedAddonWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=AnnualHomeFixedAddonWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/home/AnnualHomeFixedAddonWidget.js
// module id = 3677
// module chunks = 0